// src/components/optimiseur/api.js — l'appel commun des écrans de
// l'Optimiseur de CV : le jeton en en-tête (jamais dans l'adresse), la réponse
// lue même en erreur, et une route absente reconnue (le serveur arrive après
// l'écran : on le dit, on n'écrit rien).
import APIService from '../../services/api';

export const BASE = 'https://besoins-tat-production.up.railway.app';
export const authH = () => ({ Authorization: `Bearer ${APIService.getToken()}` });
export const routeAbsente = (r, j) => [404, 405, 501].includes(r.status) && (!j?.error || /route non trouv/i.test(j.error));

export async function appel(chemin, { method = 'GET', corps } = {}) {
  const r = await fetch(`${BASE}${chemin}`, {
    method,
    headers: { ...authH(), ...(corps !== undefined ? { 'Content-Type': 'application/json' } : {}) },
    ...(corps !== undefined ? { body: JSON.stringify(corps) } : {}),
  });
  const j = await r.json().catch(() => ({}));
  return { r, j, absente: routeAbsente(r, j) };
}

export const dateCourte = (d) => { const x = d ? new Date(d) : null; return x && !Number.isNaN(x.getTime()) ? x.toLocaleDateString('fr-CH', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''; };
export const dateHeure = (d) => { const x = d ? new Date(d) : null; return x && !Number.isNaN(x.getTime()) ? `${dateCourte(d)} · ${x.toLocaleTimeString('fr-CH', { hour: '2-digit', minute: '2-digit' })}` : ''; };
